var React = require('react');

function FlexibilityInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M649.9 561.4l76.3 45.3","stroke":"#fff","key":0}),React.createElement("path",{"d":"M650.8 561.9l-130-77.7","stroke":"#f8bf29","key":1}),React.createElement("path",{"d":"M363.3 89V0M78.5 562.2L3.7 607.8","stroke":"#fff","key":2}),React.createElement("g",{"stroke":"#f8bf29","key":3},[React.createElement("path",{"d":"M363.3 87.1v151.2","key":0}),React.createElement("path",{"d":"M363.3 86.7L78.6 229.3v332.9L367.4 758l283.1-196.2V227.5z","key":1}),React.createElement("path",{"d":"M78.6 229.3l287.5 164.5 284.4-166.3M366.1 393.8q.8 182.1 1.3 364.2M78.5 562.2l129.4-78.9","key":2})])]);
}

FlexibilityInline.defaultProps = {"viewBox":"0 0 729.7 766.5","fill":"none","strokeMiterlimit":"10","strokeWidth":"14"};

module.exports = FlexibilityInline;

FlexibilityInline.default = FlexibilityInline;
